import UAParser from 'ua-parser-js';

const parser = new UAParser();
const result = parser.getResult();

const osName = (result.os.name || '').toLowerCase();
const browserName = (result.browser.name || '').toLowerCase();

const isAndroid = osName === 'android';
const isIOS = osName === 'ios';
const isMobileSafari = isIOS && browserName === 'mobile safari';

// Device info compatible with Capacitor Device.getInfo() structure
const getDeviceInfo = () => {
  return {
    manufacturer: result.device.vendor || result.device.model || 'Unknown',
    model: result.device.model || result.os.name || 'Unknown',
    operatingSystem: result.os.name || 'Unknown',
    osVersion: result.os.version || 'Unknown',
  };
};

export default {
  isAndroid,
  isIOS,
  isMobileSafari,
  getDeviceInfo,
};

